import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import HourlyWashCountsDataGetter from '../../wash-counts/components/HourlyWashCountsDataGetter';
import { getHourlyWashCounts, getClosestsSites } from '../actions';
import { selectFromDate, selectHourlyWashCounts, selectUntilDate } from '../reducer';

export const OverviewHourlyWashCounts = (props) => {
  return <HourlyWashCountsDataGetter {...props} />;
};

const mapStateToProps = (state) => {
  return {
    hourlyWashCounts: selectHourlyWashCounts(state),
    fromDate: selectFromDate(state).toISOString(),
    untilDate: selectUntilDate(state).toISOString(),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchHourlyWashCounts: getHourlyWashCounts,
      fetchClosests: getClosestsSites,
    },
    dispatch
  );
};

const enhance = compose(injectIntl, connect(mapStateToProps, mapDispatchToProps));

export default enhance(OverviewHourlyWashCounts);
